<template>
  <v-container fluid class="pa-4 pa-sm-8">
    <v-progress-linear v-if="loading" color="primary"></v-progress-linear>
    <div v-if="manager.user">
      <v-row>
        <v-col cols="4" md="1"> </v-col>
        <v-col cols="6" md="4" align-self="center" class="ms-sm-4">
          <v-row>
            <h2 class="dark--text mb-n2">
              {{ manager.user.firstnameEn }}
              {{ manager.user.lastnameEn }}
            </h2>
          </v-row>
        </v-col>
      </v-row>

      <v-row class="mt-8 mt-sm-0">
        <v-spacer></v-spacer>
        <ManagerPayment :manager="manager" />
      </v-row>

      <v-layout wrap class="mt-8 mb-6">
        <v-tabs v-model="tabs" :mobile-breakpoint="0" background-color="bg" slider-size="3" slider-color="primary">
          <v-tab class=" text-caption text-sm-body-2 font-weight-medium text-capitalize">
            Payments
          </v-tab>

          <v-tab class=" text-caption text-sm-body-2 font-weight-medium text-capitalize">
            Plans Taken
          </v-tab>
        </v-tabs>
      </v-layout>
      <!-- {{ referralTransactions }} -->
      <v-tabs-items v-model="tabs" class="mb-6 mb-sm-0">
        <v-tab-item>
          <CelebrityPaymentHistoryTable :referralTransactions="referralTransactions" :loading="transactionListloading" />
        </v-tab-item>
        <v-tab-item>
          <CelebrityPlanTakenTable :referralTransactions="referralTransactions" :loading="transactionListloading" />
        </v-tab-item>
      </v-tabs-items>
    </div>
  </v-container>
</template>

<script>
import CelebrityPaymentHistoryTable from "../../celebrity/components/CelebrityPaymentHistoryTable.vue";
import CelebrityPlanTakenTable from "../../celebrity/components/CelebrityPlanTakenTable.vue";
import ManagerPayment from "../components/ManagerPayment.vue";
export default {
  components: {
    CelebrityPaymentHistoryTable,
    CelebrityPlanTakenTable,
    ManagerPayment,
  },
  created() {
    if (!this.hasRole(this.AdminUserPermissions.CELEBRITY_VIEW)) {
      this.$router.push({
        name: "Error404",
      });
    }
    this.getManagerById();
  },
  mounted() {
    this.$root.$on("updateGetManagerById", () => {
      this.getManagerById();
    });
  },
  watch: {
    "$route.query.managerId": {
      handler() {
        this.getManagerById();
      },
    },
  },
  methods: {
    getAllReferralTransactionsByUser() {
      this.transactionListloading = true;
      this.$apollo
        .watchQuery({
          query: require("../../celebrity/api/getAllReferralTransactionsByUser.graphql"),
          variables: { id: this.manager.user._id },
        })
        .refetch({})
        .then(data => {
          this.referralTransactions = [];
          this.transactionListloading = false;
          if (data.data.getAllReferralTransactionsByUser) {
            this.referralTransactions = data.data.getAllReferralTransactionsByUser.userReferrals;
            this.referralTransactions = this.referralTransactions.map((items, index) => ({
              ...items,
              index: index + 1,
            }));
          }
        })
        .catch(error => {
          this.transactionListloading = false;
          console.log(error);
        });
    },
    getManagerById() {
      this.loading = true;
      this.$apollo
        .watchQuery({
          query: require("../api/getManagerById.graphql"),
          variables: {
            managerId: this.$route.query.managerId,
          },
        })
        .refetch({
          variables: {
            managerId: this.$route.query.managerId,
          },
        })
        .then(data => {
          this.loading = false;

          if (data.data.getManagerById) {
            this.manager = data.data.getManagerById;
            this.getAllReferralTransactionsByUser();
          }
        })
        .catch(error => {
          this.loading = false;
          console.log(error);
        });
    },
  },
  data() {
    return {
      isDisable: true,
      imageUrl: process.env.VUE_APP_BASE_URL,
      manager: "",
      snackbar: false,
      text: "",
      tabs: null,
      btnloading: false,
      loading: true,
      transactionListloading: true,
      referralTransactions: [],
    };
  },
};
</script>
